import { Box, Link } from "@mui/material";
import { Link as RouteLink } from "react-router-dom";
import { PageHeaderTitle, PageHaderTitleProps } from "../PageHeaderTitle/PageHeaderTitle";

export type PageTitleWithLinkProps = {
  buttonLabel?: string;
  to?: string;
} & PageHaderTitleProps;

export const PageTitleWithLink = ({ title, buttonLabel: label = "View All", to = "#" }: PageTitleWithLinkProps) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <PageHeaderTitle title={title} />
      <Link component={RouteLink} to={to} sx={{ fontWeight: "500", fontSize: "1rem", lineHeight: "1.25rem", alignItems: "center", color: "secondary.main", textDecoration: "none" }}>
        {label}
      </Link>
    </Box>
  );
};
